export const data = [
  {
    specialId: 'all-users',
    name: 'All users',
    textSecondary: '558,233',
  },
  {
    specialId: 'identified-users',
    name: 'Identified users',
    textSecondary: '658,233',
    is_identified: 'True',
  },
];

export const nestedData = [
  {
    text: 'Iterio',
    nestedList: [],
  },
  {
    text: 'Intercom',
    nestedList: [],
  },
];

export const generateSegments = (segmentTypes, segments) => {
  const formatedSegmentTypes = segmentTypes.map(type => formatSegmentTypes(segments, type));
  return formatedSegmentTypes;
};

const formatSegmentTypes = (segments, type) => {
  const nestedList = segments
    .filter(segment => segment.segment_type_id === type.id)
    .map(segment => ({ ...segment, segment: true }));

  return {
    text: type.name,
    nestedList,
  };
};



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Sidebar/config.js